// extracted by mini-css-extract-plugin
export default {"button":"ExcelButton_button__lOo-7"};